import { IsNotEmpty, IsIn } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IFastcatScore } from "./fastcat-score.interface";

export class FastcatScoreDto implements IFastcatScore {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @IsNotEmpty()
  time: number;
}
